module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "textcenter"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_vm._v("Don’t miss any books in this thrilling new series:")])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "bstextcentert"
  }, [_c('strong', [_c('em', [_vm._v("FEARLESS")]), _c('sup', [_vm._v("™")])])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('em', [_vm._v("#1 Fearless"), _c('br'), _vm._v("#2 Sam"), _c('br'), _vm._v("#3 Run"), _c('br'), _vm._v("#4 Twisted"), _c('br'), _vm._v("#5 Kiss"), _c('br'), _vm._v("#6 Payback"), _c('br'), _vm._v("#7 Rebel"), _c('br'), _vm._v("#8 Heat")])]), _vm._v(" "), _c('p', {
    staticClass: "bstextcenter"
  }, [_vm._v("Available from POCKET PULSE")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-599bda9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm02.vue
// module id = 63
// module chunks = 0